import React from 'react';
import ContainerPage from '../../../../components/ContainerPage';
import HeadTitle from '../../../../components/HeadTitle';

import * as S from './styles';
import { Button } from '../../../../components';
import { useRouter } from '../../../../contexts/RouterContext';
import Radio from '../../../../components/Radio';
import { PAGES } from '../../../../Router/pages';
import { CallCenterModal } from './components/CallCenterModal';

export const PregnantInfo = () => {
  const router = useRouter();

  const [patient, setPatient] = React.useState<{
    hasPregnantProgram?: boolean;
  }>();

  const [isCallCenterModalVisible, setIsCallCenterModalVisible] = React.useState(false);

  function toggleHasPregnantProgram(hasPregnantProgram: boolean) {
    setPatient({ ...patient, hasPregnantProgram });
  }

  function isButtonDisable() {
    if (patient?.hasPregnantProgram === true || patient?.hasPregnantProgram === false) return false;
    return true;
  }

  function handleContinue() {
    if (patient?.hasPregnantProgram) setIsCallCenterModalVisible(r => !r);
    else router.goTo(PAGES.SERVICE_TYPE_PAGE.id);
  }

  return (
    <ContainerPage childrenFooter={<Button disabled={isButtonDisable()} onClick={handleContinue} title="Continuar" />}>
      <HeadTitle title="Precisamos de mais algumas informações" goBack={router.goBack} />
      <S.Container>
        <S.Info>Participa do Programa Engravida?</S.Info>
        <S.OptionsWrapper>
          <S.Option isSelected={patient?.hasPregnantProgram === true} onClick={() => toggleHasPregnantProgram(true)}>
            <S.LabelOption>Sim</S.LabelOption>
            <Radio isChecked={patient?.hasPregnantProgram === true} />
          </S.Option>
          <S.Option isSelected={patient?.hasPregnantProgram === false} onClick={() => toggleHasPregnantProgram(false)}>
            <S.LabelOption>Não</S.LabelOption>
            <Radio isChecked={patient?.hasPregnantProgram === false} />
          </S.Option>
        </S.OptionsWrapper>
      </S.Container>
      <CallCenterModal visible={isCallCenterModalVisible} onClose={() => setIsCallCenterModalVisible(r => !r)} />
    </ContainerPage>
  );
};
